<template>
  <div
    class="no-icon-card"
  >
    <h3 class="flex">
      <span class="title-slot">
        <slot name="title"></slot>
      </span>
    </h3>
    <div class="main-slot">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.no-icon-card {
  display: grid;
  grid-template-columns: 1fr;
  padding: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  line-height: rem-calc(24);
  color: #101828;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  h3.flex {
    font-weight: 500;
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
    margin-top: 0;
    margin-bottom: rem-calc(6);
    font-size: rem-calc(16);
  }

  .main-slot {
    text-wrap: pretty;
  }
}

</style>
